import { useEffect, useState, } from "react"
import { UrlApi } from "../../../../../services/apirest";
import ModalRechazarProveedor from "../ModalRechazarProveedor";
import {
  Box, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Checkbox, Button, TablePagination, Tooltip
} from "@mui/material";
import { validar } from "../validaciones";

export default function DataImputaciones(props) {
  const [imputaciones, setImputaciones] = useState([]);
  const [modalRechazarOpen, setModalRechazarOpen] = useState(false);
  const [rechazando, setRechazando] = useState(false);
  const soloDetalle = Boolean(props.soloDetalle);
  const esSectorCompras = Number(localStorage.getItem("sector")) === 4;
  let nro_cuit = props.datos.nro_cuit;

  const erroresCoeficientes =
    props.editar === 1
      ? validar(props.regIIBBmanual || [], [], [], {
          regIIBBpadron: props.regIIBBpadron || [],
          id_convenio: props.datos?.id_convenio,
          cicloFiscalActual: props.cicloFiscalActual,
        })
      : [];
  const puedeGuardar = erroresCoeficientes.length === 0;

  const getImputaciones = () => {
    fetch(UrlApi + '/imputacion_gastos')
      .then((data) => data.json())
      .then((data) => setImputaciones(data))
  };

  const getImputacionesProveedor = () => {
    fetch(UrlApi + `/imputacion_proveedores/${nro_cuit}`)
      .then((data) => data.json())
      .then((data) => props.setImputacionesSeleccionadas(data))
  }

  useEffect(() => {
    getImputaciones();
    getImputacionesProveedor()
  }, []);


  // Manejar selección de imputaciones
  const handleSeleccion = (imputacion) => {
    if (soloDetalle) return;

    props.setImputacionesSeleccionadas(prev => {
      const existe = prev.some(
        item => item.idimputacion === imputacion.idimputacion
      );

      if (existe) {
        return prev.filter(item => item.idimputacion !== imputacion.idimputacion);
      }

      const nuevo = {
        idimputacion: imputacion.idimputacion,
        nro_cuit: nro_cuit,
        usuario: localStorage.getItem('user')
      };
      return [...prev, nuevo];
    });
  };

  // Estados para el paginado
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Manejadores de cambio
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Cálculo de las filas a mostrar en la página actual
  const filasPaginadas = imputaciones.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );



  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: "12px",
          border: "1px solid #e0e6ed",
          overflow: "hidden",
          backgroundColor: "#fff"
        }}
      >
        <TableContainer>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox" sx={{ backgroundColor: "#f8f9fa" }} />
                <TableCell sx={{ backgroundColor: "#f8f9fa", fontWeight: 700, color: "#5c6a7a", fontSize: "0.75rem" }}>CÓDIGO</TableCell>
                <TableCell sx={{ backgroundColor: "#f8f9fa", fontWeight: 700, color: "#5c6a7a", fontSize: "0.75rem" }}>DESCRIPCIÓN</TableCell>
                <TableCell sx={{ backgroundColor: "#f8f9fa", fontWeight: 700, color: "#5c6a7a", fontSize: "0.75rem" }}>CUENTA CONTABLE</TableCell>
                <TableCell align="right" sx={{ backgroundColor: "#f8f9fa", fontWeight: 700, color: "#5c6a7a", fontSize: "0.75rem" }}>ALÍCUOTA</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filasPaginadas.map((imputacion) => {
                const isSelected = props.imputacionesSeleccionadas.some(
                  (item) => item.idimputacion === imputacion.idimputacion
                );

                return (
                  <TableRow
                    key={imputacion.idimputacion}
                    hover={!soloDetalle}
                    selected={isSelected}
                    onClick={soloDetalle ? undefined : () => handleSeleccion(imputacion)}
                    sx={{ cursor: soloDetalle ? "default" : "pointer" }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isSelected}
                        disabled={soloDetalle}
                        color="success"
                        size="small"
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.8rem" }}>#{imputacion.idimputacion}</TableCell>
                    <TableCell sx={{ fontSize: "0.85rem", fontWeight: 500 }}>{imputacion.descripcion}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", color: "#637381" }}>{imputacion.cuenta_contable}</TableCell>
                    <TableCell align="right" sx={{ fontSize: "0.85rem", fontWeight: 600 }}>{imputacion.alicuota}%</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Componente de Paginación */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={imputaciones.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Filas por página:"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          sx={{ borderTop: "1px solid #e0e6ed" }}
        />
      </Paper>

      {!props.soloDetalle ? (
      <Box sx={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: 1, mt: 2, mb: 5 }}>
        {props.editar === 0 && props.handleRechazarClick ? (
          <Button
            variant="contained"
            color="error"
            onClick={() => setModalRechazarOpen(true)}
            sx={{ borderRadius: "8px", fontWeight: 600, mb: 1 }}
          >
            Rechazar
          </Button>
        ) : null}
        {props.editar === 1 ? (
          <Tooltip
            title={
              puedeGuardar
                ? ""
                : erroresCoeficientes.join(" | ")
            }
          >
            <span>
              <Button
                variant="contained"
                color="success"
                disabled={!puedeGuardar}
                onClick={props.handleGuardarClick}
                sx={{ borderRadius: "8px", fontWeight: 600, mb: 1, mr: 1 }}
              >
                Guardar cambios
              </Button>
            </span>
          </Tooltip>
        ) : esSectorCompras ? (
          <Button
            variant="contained"
            color="success"
            disabled={Boolean(props.revisado_compras)}
            onClick={() => props.handleGuardarClick("compras")}
            sx={{ borderRadius: "8px", fontWeight: 600, mb: 1, mr: 1 }}
          >
            Aprobado por área compra
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            disabled={Boolean(props.revisado_impuestos)}
            onClick={() => props.handleGuardarClick("impuestos")}
            sx={{ borderRadius: "8px", fontWeight: 600, mb: 1, mr: 1 }}
          >
            Aprobado por área impuesto
          </Button>
        )}
      </Box>
      ) : null}

      {props.editar === 0 && props.handleRechazarClick && !props.soloDetalle ? (
        <ModalRechazarProveedor
          open={modalRechazarOpen}
          onClose={() => !rechazando && setModalRechazarOpen(false)}
          email={props.datos?.email}
          razonSocial={props.datos?.razon_social}
          nroCuit={props.datos?.nro_cuit}
          loading={rechazando}
          onConfirm={async (motivo) => {
            setRechazando(true);
            try {
              const ok = await props.handleRechazarClick(motivo);
              if (ok) {
                setModalRechazarOpen(false);
              }
            } finally {
              setRechazando(false);
            }
          }}
        />
      ) : null}
    </Box>
  );
};

